import styled from 'styled-components'
import { MeasurementIcon } from '@sainsburys-tech/bolt-icons'

const DimensionWrapper = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 8px;
`

const IconWrapper = styled(MeasurementIcon)`
  margin-right: 5px;
`

const DimensionText = styled.p`
  margin-right: auto;

  && {
    margin-bottom: 0;
  }
`

export { DimensionWrapper, IconWrapper, DimensionText }
